import { Single } from 'infrastructure/api'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { platformFeaturesWithDefaultAtom } from './platformFeatures.atoms'
import { productPlatformFeaturesAtomFamily } from './productPlatformFeatures.atoms'
import { useCallback, useMemo } from 'react'
import { setProductPlatformFeature } from '../providers/mutations'

export const PRODUCT_SPECIFIC_FEATURES = [
  'ai-question-feedback',
  'ai-auto-scoring',
  'ai-practice-problems',
  'ai-lesson-clipper',
  'ai-custom-lessons',
  'ai-curriculum-coach',
]

export function useProductSpecificPlatformFeatures(): Single.PlatformFeature[] {
  const platformFeatures = useAtomValue(platformFeaturesWithDefaultAtom)

  return useMemo(() => {
    return platformFeatures.filter((feature) =>
      PRODUCT_SPECIFIC_FEATURES.includes(feature.name),
    )
  }, [platformFeatures])
}

export function useProductPlatformFeatures(
  productId: number,
): Single.ProductPlatformFeature[] {
  const productPlatformFeatures = useAtomValue(
    productPlatformFeaturesAtomFamily(productId),
  )

  return useMemo(() => {
    return productPlatformFeatures.product_platform_features
  }, [productPlatformFeatures])
}

export function useProductPlatformFeaturesEditable(productId: number): boolean {
  const productPlatformFeatures = useAtomValue(
    productPlatformFeaturesAtomFamily(productId),
  )

  return useMemo(() => {
    return productPlatformFeatures.is_editable
  }, [productPlatformFeatures])
}

export function useProductSpecificPlatformFeatureUpdate(productId: number) {
  return useCallback(
    (platformFeatureId: number, isEnabled: boolean) => {
      return setProductPlatformFeature(productId, platformFeatureId, isEnabled)
    },
    [productId],
  )
}

export const useRefreshProductPlatformFeatures = () => {
  return useCallback((productId: number) => {
    return productPlatformFeaturesAtomFamily.remove(productId)
  }, [])
}
